import { useState } from "react";
import styles from "./DrugIndicationIndex.module.scss";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const DrugIndicationIndex = ({ drugs, isAppMode }) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const visibleDrugs = expanded
    ? drugs
    : isAppMode
      ? drugs?.slice(0, 2)
      : drugs?.slice(0, 4);
  const handleDrugIndexClick = (drugName) => {
    const basePath = isAppMode ? "/app" : "";
    navigate(`${basePath}/drugOverview?drug=${encodeURIComponent(drugName)}`);
  };
  return (
    <div className={styles.drugIndexwrapper}>
      <div className={styles.drugTitleDiv}>
        <span
          className={
            isAppMode ? styles.appDrugIndextitle : styles.drugIndextitle
          }
        >
          Drug Index
        </span>
      </div>

      <div
        className={classNames(
          styles.drugList,
          isAppMode && styles.appModeDrugList,
        )}
      >
        {visibleDrugs.map((drugObj, index) => {
          const drugName = Object.keys(drugObj)[0];

          return (
            <button
              key={index}
              className={classNames(
                styles.drugItem,
                isAppMode && styles.appModeDrugItem,
              )}
              onClick={() => handleDrugIndexClick(drugName)}
            >
              <i
                className={classNames(
                  `tg-icons-Drug ${!isAppMode ? styles.iconSize : styles.appIconSize}`,
                )}
              ></i>
              <span>{drugName}</span>
            </button>
          );
        })}
      </div>

      {drugs.length > 4 && (
        <div className={styles.seeAll}>
          <button
            className={styles.toggleButton}
            onClick={() => setExpanded(!expanded)}
            data-testid="search-within-result"
          >
            <span className={styles.seeAllText}>
              {!expanded ? "See all" : "See fewer"}{" "}
            </span>
            <i
              className={
                !expanded
                  ? `fa banner-head-topic fa-angle-down`
                  : `fa banner-head-topic fa-angle-up`
              }
            />
          </button>
        </div>
      )}

      <span
        className={
          isAppMode ? styles.appDrugIndicationText : styles.drugIndicationText
        }
      >
        Drug Indications
      </span>
    </div>
  );
};

DrugIndicationIndex.propTypes = {
  drugs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.number)),
  isAppMode: PropTypes.bool,
};

export default DrugIndicationIndex;
